export var HUB_ROUTE_NAME = 'hub';
export var HUB_ROUTE_PATH = '/';